<template>
    <b-row>
        <b-col cols="12">
            <h4 class="mb-3">
                {{ $t('general.abono', { abono: teatro.texto_abono.charAt(0).toUpperCase() + teatro.texto_abono.slice(1) }) }} {{ index + 1 }}
            </h4>
        </b-col>
        <b-col cols="12">
            <b-row>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.name"
                        :id="'nombre-' + index"
                        rules="required"
                        :label="$t('formularios.nombre')"
                        :name="$t('formularios.nombre')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4" v-if="abono.identification?.type !== 'NIF'">
                    <FormInput
                        v-model="abono.lastName"
                        rules="required"
                        :id="'apellidos-' + index"
                        :label="$t('formularios.apellidos')"
                        :name="$t('formularios.apellidos')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="genero" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>{{ $t('formularios.genero') }}</label>
                            <multiselect
                                v-model="abono.gender_object"
                                label="name"
                                track-by="id"
                                class="custom-multiselect"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                :id="'genero-' + index"
                                :placeholder="$t('formularios.genero')"
                                :options="generos"
                                @select="formatGender"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                                {{ errors[0] }}
                            </span>
                        </div>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <DocumentoTipo
                        :value="abono.identification.type"
                        :index="index"
                        @input="val => { abono.identification.type = val; }"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <DocumentoValor
                        :type="abono.identification.type"
                        :value="abono.identification.value"
                        :index="index"
                        @input="val => { abono.identification.value = val; }"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Paises
                            ref="paises"
                            :pais="pais?.iso3 ? pais : null"
                            :desactivar="false"
                            @paisesCargados="onPaisesCargados"
                            @rellenarPais="rellenarPais"
                            @selected="opt => { pais = opt; abono.address.country = opt.iso3; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Provincias
                            ref="provincias"
                            :desactivar="false"
                            :pais="pais.id"
                            :provincia="provincia"
                            @provinciasCargadas="onProvinciasCargadas"
                            @selected="opt => { provincia = opt; abono.address.state = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Locations
                            :localidad="localidad"
                            :desactivar="false"
                            :provincia="provincia"
                            @localidadesCargadas="onLocalidadesCargadas"
                            @selected="opt => { abono.address.city = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.address.zipCode"
                        rules="required"
                        :id="'cp-' + index"
                        :label="$t('formularios.cp')"
                        :name="$t('formularios.cp')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.address.streetLine1"
                        rules="required"
                        :id="'direccion-' + index"
                        :label="$t('formularios.domicilio')"
                        :name="$t('formularios.domicilio')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4" v-if="abono.identification?.type !== 'NIF'">
                    <FormInput
                        v-model="abono.birthday"
                        rules="required"
                        :id="'fecha-nacimiento-' + index"
                        type="date"
                        :label="$t('formularios.nacimiento')"
                        :name="$t('formularios.nacimiento')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.email"
                        rules="required"
                        :vid="'confirmation-' + index"
                        :id="'email-' + index"
                        type="email"
                        :label="$t('formularios.email')"
                        :name="$t('formularios.email')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.email_confirm"
                        :id="'email-confirm-' + index"
                        type="email"
                        :rules="'required|confirmed_ci:@confirmation-' + index"
                        :label="$t('formularios.confirmar_email')"
                        :name="$t('formularios.confirmar_email')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <label :for="'telefono-' + index">{{ $t('formularios.telefono') }}</label>
                        <PhoneInput
                            :name="'telefono-' + index" 
                            :phone="abono.phone ?? null" 
                            :required="true"
                            :error_telefono="abono.error_telefono"
                            @setNumber="(number) => abono.phone = number"
                            @validNumber="(valid) => abono.isValidNumber = valid"
                        />
                    </div>
                </b-col>
                <b-col cols="12" class="m-3">
                    <hr/>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    import Provincias from "../../../../common/forms/Provincias";
    import Locations from "../../../../common/forms/Locations";
    import Paises from "../../../../common/forms/Paises";
    import PhoneInput from '@/components/common/PhoneInput';
    import DocumentoTipo from "@/components/common/DocumentoTipo";
    import DocumentoValor from "@/components/common/DocumentoValor";

    export default {
        props: {
            datosAbonosLocal: {
                type: Object,
                required: true
            },
            generos: {
                type: Array,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                provincia: null,
                localidad: null,
                pais: { id: 0 }
            };
        },
        methods: {
            rellenarPais(pais) {
                this.abono.address.country = pais.iso3;
            },
            onPaisesCargados(paises) {
                if (this.abono.address.country) {
                    const encontrado = paises.find(p => p.iso3 === this.abono.address.country);
                    this.pais = encontrado || { id: 0 };
                }
            },
            onProvinciasCargadas(provincias) {
                if (this.abono.address.state) {
                    const encontrado = provincias.find(p => p.nombre === this.abono.address.state);
                    this.provincia = encontrado || null;
                }
            },
            onLocalidadesCargadas(localidades) {
                if (this.abono.address.city) {
                    const encontrado = localidades.find(l => l.nombre === this.abono.address.city);
                    this.localidad = encontrado || null;
                }
            },
            formatGender(option) {
                switch (option.name) {
                    case 'Hombre':
                        this.abono.gender = 'MALE';
                        break;
                    case 'Mujer':
                        this.abono.gender = 'FEMALE';
                        break;
                    default:
                        this.abono.gender = 'OTHER';
                        break;
                }
            }
        },
        computed: {
            abono: {
                get() {
                    return this.datosAbonosLocal;
                },
                set(value) {
                    this.$emit('update:datosAbonosLocal', value);
                }
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        created() {
            if (this.teatro.provincia) {
                this.provincia = this.teatro.provincia;
            }
        },
        components: {
            Provincias, Paises, Locations, PhoneInput, DocumentoTipo, DocumentoValor
        }
    }
</script>